// extracted by mini-css-extract-plugin
export var clickableArea = "ReviewItem_clickableArea__InwY2";
export var content = "ReviewItem_content__9t0sV";
export var item = "ReviewItem_item__Unc3Z";
export var reviewText = "ReviewItem_reviewText__LyuOB";
export var thumbnailContainer = "ReviewItem_thumbnailContainer__8-SPK";
export var title = "ReviewItem_title__pY9iU";
export var verifiedTag = "ReviewItem_verifiedTag__akT4a";